<template>
  <main class="organism-ticket-thread">
    <section name="header">
      <div class="header__container">
        <label class="header__text--topic">Ticket Detail</label>
        <b-badge
          pill
          :variant="badgeVariant(status)"
          class="badge--style tag--space"
          >{{ badgeStatus(status) }}
        </b-badge>
      </div>
    </section>

    <!-- Customer Start-->
    <section name="customer">
      <div class="customer__container">
        <div class="customer__idc w-100 d-flex">
          <label class="text--header">{{ contractIdLabel }}</label>
          <label class="text--body font-weight-bold">{{
            customer.idcId ? `${customer.idcId}` : "-"
          }}</label>
        </div>
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Ticket Type</label>
          <label class="text--body">{{
            getTicketType(customer.ticketType)
          }}</label>
        </div>
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Ticket ID</label>
          <label class="text--body">{{ customer.ticketId }}</label>
        </div>
        <div class="customer__name w-100 d-flex">
          <label class="text--header">Customer Name</label>
          <label class="text--body">{{ customer.name }}</label>
        </div>
        <div class="customer__email w-100 d-flex">
          <label class="text--header">Email Addresses</label>
          <label class="text--body">{{ customer.email }}</label>
        </div>
        <div class="customer__phone w-100 d-flex">
          <label class="text--header">Phone Numbers</label>
          <label class="text--body">{{ customer.phone }}</label>
        </div>
      </div>
    </section>
    <!-- customer End-->

    <!-- Ticket & Ticket Detail Start-->
    <section name="ticket-ticket-detail">
      <hr />
      <div class="ticket-ticket-detail__container">
        <!-- Ticket Start-->
        <div class="ticket__container" :class="{ 'w-md-100': isEditTicket }">
          <div
            class="ticket__topic d-flex"
            :class="{ 'w-100 align-items-center': isEditTicket }"
          >
            <label class="text--header">Topic</label>
            <label v-if="!isEditTicket" class="text--body">{{
              ticket.topic.name || "-"
            }}</label>
            <div v-else class="text-width">
              <atom-select
                v-model="editTicket.topic"
                label="name"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :option="topicList"
              ></atom-select>
            </div>
          </div>
          <div
            class="ticket__subject w-100 d-flex"
            :class="{ 'align-items-center': isEditTicket }"
          >
            <label class="text--header">Topic Subject</label>
            <label v-if="!isEditTicket" class="text--body">{{
              ticket.subject
            }}</label>
            <div v-else class="text-width">
              <atom-input
                v-model="editTicket.subject"
                :isError="isErrorTicket.subject"
                errorMessage="Please enter subject"
              ></atom-input>
            </div>
          </div>
          <div
            class="ticket__detail w-100 d-flex"
            :class="{ 'align-items-center': isEditTicket }"
          >
            <label class="text--header">Detail</label>
            <div v-if="!isEditTicket" class="text--body">
              <span>{{ ticket.detail }}</span>
            </div>
            <div v-else class="text-width">
              <atom-text-area
                v-model="editTicket.detail"
                placeholder="Detail"
                :isAsterisk="true"
                :isDisable="false"
                :isError="isErrorTicket.detail"
                errorMessage="Please enter detail"
                :isResizable="true"
              ></atom-text-area>
            </div>
          </div>
          <div
            class="ticket__attachments d-md-flex"
            :class="{ 'align-items-center': isEditTicket }"
          >
            <label class="text--header align-items-center">Attachment</label>
            <div v-if="!isEditTicket" class="text--body">
              <atom-file-attachment-list
                v-if="attachmentFileList.length"
                :attachmentList="attachmentFileList"
                :isDeletable="false"
              ></atom-file-attachment-list>
              <label v-else class="text--body">-</label>
            </div>

            <div v-else class="attachment-width">
              <atom-file-attachment-input
                id="internalTicketDetailAttachment"
                title="Attachments (Max. 25Mb)"
                @onUpdateFile="onUpdateTicketAttachment"
              ></atom-file-attachment-input>
              <atom-file-attachment-list
                v-if="attachmentFileList.length"
                class="mt-1"
                :attachmentList="attachmentFileList"
                @onRequestDeleteAttachment="onRequestDeleteAttachment"
              ></atom-file-attachment-list>
            </div>
          </div>
          <div
            class="ticket__priority d-flex mt-2"
            :class="{ 'align-items-center': isEditTicket }"
          >
            <label class="text--header">Priority</label>
            <label v-if="!isEditTicket" class="text--body">{{
              ticket.priority ? ticket.priority.name : "-"
            }}</label>
            <div v-else class="text-width">
              <atom-select
                v-model="editTicket.priority"
                label="name"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :option="priorityList"
              ></atom-select>
            </div>
          </div>
        </div>
        <!-- Ticket End-->

        <!-- TicketDetail Start-->
        <div class="ticket-detail__container">
          <div class="ticket-detail__department w-100 d-flex">
            <label class="text--header">Site</label>
            <label class="text--body">{{
              customer.siteName || "Site not found"
            }}</label>
          </div>
          <div class="ticket-detail__department w-100 d-flex mt-1">
            <label class="text--header">Department</label>
            <label class="text--body">{{
              ticketDetail.department ? ticketDetail.department.name : "-"
            }}</label>
          </div>
          <div class="ticket-detail__source w-100 d-flex">
            <label class="text--header">Source</label>
            <label class="text--body">{{
              ticketDetail.source ? ticketDetail.source.name : "-"
            }}</label>
          </div>
          <div class="ticket-detail__created-by w-100 d-flex">
            <label class="text--header">Created by</label>
            <label class="text--body">{{ ticketDetail.createdBy }}</label>
          </div>
          <div class="ticket-detail__updated-by w-100 d-flex">
            <label class="text--header">Updated by</label>
            <label class="text--body">{{ ticketDetail.updatedBy }}</label>
          </div>
        </div>
        <!-- ticket-detail End-->

        <div
          v-if="
            !isEditTicket && status !== 'CLOSED' && hasUpdateTicketPermission
          "
          class="ticket-ticket-detail__button-edit"
        >
          <atom-button
            buttonId="ticket__button-edit"
            buttonStyle="flat"
            buttonColor="secondary"
            :isOnlyIcon="true"
            iconLeft="Edit2Icon"
            @click="onClickEditTicket"
          ></atom-button>
        </div>

        <div v-if="isEditTicket" class="button__height mt-3">
          <div class="button__container">
            <div class="button__save">
              <atom-button
                buttonId="button__save-edit-ticket"
                @click="onClickSaveEditTicket"
                >Save Changes</atom-button
              >
            </div>
            <div class="button__cancel">
              <atom-button
                buttonId="button__cancel-edit-ticket"
                buttonStyle="border"
                buttonColor="secondary"
                @click="onClickCancelEditTicket"
                >Cancel</atom-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Ticket & TicketDetail End-->

    <!-- Ticket Thread Start-->
    <section name="ticket-thread">
      <hr />
      <div class="ticket-thread__container">
        <label class="ticket-thread__header">TICKET DETAILS</label>

        <div class="duration__container d-flex">
          <div class="duration__created">
            <label class="duration__text--header">Created Date</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.createdAt
            }}</label>
          </div>
          <div class="duration__closed">
            <label class="duration__text--header">Closed Date</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.closedAt || "-"
            }}</label>
          </div>
          <div class="duration__duration">
            <label class="duration__text--header">Duration</label>
            <label class="duration__text--body w-100">{{
              ticketTimestamp.closedAt ? ticketTimestamp.duration : "-"
            }}</label>
          </div>
        </div>

        <molecule-internal-thread
          :type="type"
          :status="status"
          :internalThreadList="internalThreadList"
          :activityCommunityList="activityCommunityList"
          :currentDepartment="ticketDetail.department"
          :departmentList="departmentList"
          :staffList="staffList"
          :replyTemplateOptions="replyTemplateOptions"
          :hasUpdatePermission="hasUpdateTicketPermission"
          @onClickAddTicketInternal="onClickAddTicketInternal"
          @onClickAddTicketActivity="onClickAddTicketActivity"
          @onRequestDeleteAttachment="onRequestDeleteAttachmentFromThread"
        ></molecule-internal-thread>
      </div>
    </section>
    <!-- Ticket Detail End-->

    <section name="escalation">
      <hr />
      <div class="p-2">
        <molecule-escalation-selection
          v-model="escalationSelected"
          :escalation-template-list="escalationTemplateList"
          :escalation-name="escalationDetail.name"
          :description="escalationDetail.description"
          :levels="escalationDetail.levels"
          :is-show-info="isNoEscalationSelected"
          :is-disable-select="!!ticketDetailData.escalationId || !hasReadTicketEscalationPermission"
          :hasUpdatePermission="hasUpdateTicketPermission"
          @onClickEscalateLevel="onClickEscalateLevel"
        />
      </div>

      <div
        v-if="
          isNoEscalationSelected &&
          escalationSelected &&
          hasUpdateTicketPermission
        "
        class="d-flex justify-content-end p-2"
      >
        <div class="button__save">
          <atom-button
            buttonId="button__save-edit-ticket"
            @click="onClickSaveEditTicket"
            >Save Changes</atom-button
          >
        </div>
        <div class="button__cancel">
          <atom-button
            buttonId="button__cancel-edit-ticket"
            buttonStyle="border"
            buttonColor="secondary"
            @click="onClickCancelSelectEscalation"
            >Cancel</atom-button
          >
        </div>
      </div>
    </section>

    <!-- Modal Start -->
    <section name="modal">
      <molecule-modal-dialog
        modalId="ticket-detail__confirm-edit-ticket"
        :isTextCenter="true"
        :textTitle="`Do you want to save\n“${ticketId}” ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmSaveEditTicket"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-cancel-edit-ticket"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmCancelEditTicket"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="ticket-detail__confirm-cancel-edit-escalation"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmCancelSelectEscalation"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </main>
</template>

<script>
import { BBadge } from "bootstrap-vue"

import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomFileAttachmentList from "@/components/atoms/AtomFileAttachmentList.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"

import MoleculeInternalThread from "@/components/molecules/portal/ticket/MoleculeInternalThread.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeEscalationSelection from "@/components/molecules/portal/escalationSelection/MoleculeEscalationSelection.vue"
import { escalateTicketEscalationByTicketId } from "@/api/module-1/escalation"
import { TicketType } from "@/constants"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "OrganismTicketDetail",
  components: {
    BBadge,
    MoleculeInternalThread,
    AtomButton,
    AtomSelect,
    AtomInput,
    AtomFileAttachmentInput,
    AtomFileAttachmentList,
    AtomTextArea,
    MoleculeModalDialog,
    MoleculeEscalationSelection,
  },
  mixins: [mixins, mixinsUser, mixinsValidator],
  props: {
    ticketId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    customerData: {
      type: Object,
      required: false,
      default: () => {},
    },
    ticketData: {
      type: Object,
      required: false,
      default: () => {},
    },
    ticketDetailData: {
      type: Object,
      required: false,
      default: () => {},
    },
    departmentList: {
      type: Array,
      required: true,
    },
    priorityList: {
      type: Array,
      required: true,
    },
    sourceList: {
      type: Array,
      required: true,
    },
    topicList: {
      type: Array,
      required: true,
    },

    // ticket detail
    ticketTimestamp: {
      type: Object,
      required: true,
    },
    internalThreadList: {
      type: Array,
      required: true,
    },
    activityCommunityList: {
      type: Array,
      required: true,
    },
    staffList: {
      type: Array,
      required: true,
    },

    // reply template
    replyTemplateOptions: {
      type: Array,
      required: true,
    },

    escalationTemplateList: {
      type: Array,
      required: true,
    },
    escalation: {
      type: Object,
      required: false,
      default: () => {},
    },
    escalationDetail: {
      type: Object,
      required: false,
      default: () => {},
    },
    isNoEscalationSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    "onClickDownloadFile",
    "onClickSaveEditTicket",
    "onClickAddTicketInternal",
    "onClickAddTicketActivity",
    "changeEscalationTemplate",
    "onClickEscalateLevel",
  ],
  data() {
    return {
      modalId: null,

      // customer
      customer: {
        idcId: "",
        name: "",
        email: "",
        phone: "",
      },

      // ticket
      isEditTicket: false,
      ticket: {
        topic: {
          id: "",
          name: "",
        },
        subject: "",
        detail: "",
        attachments: {
          fileName: "",
          path: "",
        },
        priority: "",
      },
      editTicket: {
        topic: "",
        subject: "",
        detail: "",
        attachments: "",
        priority: "",
      },
      isValidateEditTicket: false,
      isErrorTicket: {
        subject: false,
        detail: false,
      },

      // ticket-detail
      ticketDetail: {
        department: {},
        source: "",
        createdBy: "",
        updatedBy: "",
      },

      attachmentFileList: [],
    }
  },
  computed: {
    escalationSelected: {
      get() {
        return this.escalation
      },
      set(newValue) {
        this.$emit("changeEscalationTemplate", newValue)
      },
    },

    hasUpdateTicketPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_WRITE)
    },
    hasReadTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_READ)
    },
  },
  watch: {
    isEditTicket: {
      immediate: true,
      deep: true,
      handler() {
        if (this.isValidateEditTicket) this.validateEditTicket()
      },
    },
    ticketData: {
      immediate: true,
      deep: true,
      handler() {
        if (this.ticketData) {
          this.getDataTicketDetail()
          this.setEditTicketToOriginalData()
        }
      },
    },
    ticketDetailData: {
      immediate: true,
      deep: true,
      handler() {
        if (this.ticketDetailData) {
          this.getDataTicketDetail()
          this.setEditTicketToOriginalData()
        }
      },
    },
  },
  methods: {
    // get data
    getDataTicketDetail() {
      this.customer = this.customerData
      this.ticket = this.ticketData
      this.ticketDetail = this.ticketDetailData

      this.setEditTicketToOriginalData()
    },

    setEditTicketToOriginalData() {
      this.editTicket = {
        topic: this.ticket.topic,
        subject: this.ticket.subject,
        detail: this.ticket.detail,
        attachments: null,
        priority: this.ticket.priority,
      }
      if (this.ticketData.attachments) {
        this.attachmentFileList = this.ticketData.attachments.map(
          (attachment) => {
            return {
              id: attachment.attachmentId,
              name: attachment.fileName,
              originalFileName: attachment.originalFileName,
              path: attachment.attachmentPath,
              createdBy: attachment.createdBy,
            }
          }
        )
      } else {
        this.attachmentFileList = []
      }
    },

    // download file
    onClickDownloadFile() {
      this.$emit("onClickDownloadFile", this.ticket.attachments)
    },

    // edit ticket
    onClickEditTicket() {
      this.isEditTicket = true
    },

    onClickSaveEditTicket() {
      this.isValidateEditTicket = true
      this.validateEditTicket()
      if (!this.isErrorTicket.subject && !this.isErrorTicket.detail) {
        this.modalId = "ticket-detail__confirm-edit-ticket"
        this.openModal(this.modalId)
      }
    },

    clickConfirmSaveEditTicket() {
      const editTicketRequest = {
        siteId: this.customer.siteId,
        topicId: this.editTicket.topic.id,
        ticketSubject: this.editTicket.subject,
        ticketDetail: this.editTicket.detail,
        priority: this.editTicket.priority.id,
        escalationId: this.escalationSelected?.escalationId,
      }
      const uploadAttachment = this.editTicket.attachments
      this.$emit("onClickSaveEditTicket", editTicketRequest, uploadAttachment)
      this.isEditTicket = false
      this.closeModal()
    },

    onClickCancelEditTicket() {
      if (JSON.stringify(this.editTicket) !== JSON.stringify(this.ticket)) {
        this.modalId = "ticket-detail__confirm-cancel-edit-ticket"
        this.openModal(this.modalId)
      } else this.isEditTicket = false
    },

    onClickCancelSelectEscalation() {
      this.modalId = "ticket-detail__confirm-cancel-edit-escalation"
      this.openModal(this.modalId)
    },

    clickConfirmCancelSelectEscalation() {
      this.$router.push({ name: "internalTicketManagement" })
    },

    clickConfirmCancelEditTicket() {
      this.isEditTicket = false
      this.ticket = this.ticketData
      this.setEditTicketToOriginalData()
      this.closeModal()
    },

    // ticket detail
    async onClickAddTicketInternal(thread) {
      const addInternal = {
        ticketId: this.ticketId,
        threadType: "INTERNAL",
        threadMessage: thread.message,
        additionalReceiver:
          thread.sentTo === "Person" && thread.staff
            ? {
                username: thread.staff.id,
              }
            : undefined,
        transferDepartmentRequest:
          thread.sentTo === "Department" && thread.department
            ? {
                departmentId: thread.department.id,
              }
            : undefined,
        closeTicket: thread.isCloseTicket,
      }
      const attachment = thread.attachment
      this.$emit("onClickAddTicketInternal", addInternal, attachment)
      if (addInternal.closeTicket)
        this.$router.push({ name: "internalTicketManagement" })
    },

    onClickAddTicketActivity(thread) {
      const addActivity = {
        ticketId: this.ticketId,
        threadType: "GLOBAL",
        threadMessage: thread.message,
        closeTicket: thread.isCloseTicket,
      }
      const attachment = thread.attachment
      this.$emit("onClickAddTicketActivity", addActivity, attachment)
    },

    // validate edit ticket
    validateEditTicket() {
      // subject
      if (!this.editTicket.subject || this.isEmptyString(this.editTicket.subject)) this.isErrorTicket.subject = true
      else this.isErrorTicket.subject = false
      // detail
      if (!this.editTicket.detail || this.isEmptyString(this.editTicket.detail)) this.isErrorTicket.detail = true
      else this.isErrorTicket.detail = false
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    badgeVariant(status) {
      if (status === "OPENED") return "light-primary"
      else if (status === "IN_PROGRESS") return "light-warning"
      else return "light-secondary"
    },

    badgeStatus(status) {
      if (status === "OPENED") return "Opened"
      else if (status === "IN_PROGRESS") return "In Progress"
      else return "Closed"
    },

    onUpdateTicketAttachment(fileList) {
      this.editTicket.attachments = fileList
    },

    onRequestDeleteAttachment(file) {
      this.$emit("onRequestDeleteAttachment", file)
    },

    onRequestDeleteAttachmentFromThread(file, thread) {
      this.$emit("onRequestDeleteAttachmentFromThread", file, thread)
    },

    onClickEscalateLevel() {
      this.$emit("onClickEscalateLevel", this.ticketId)
    },

    getTicketType(ticketType) {
      switch (ticketType) {
        case TicketType.NORMAL:
          return "Ticket"
        case TicketType.INCIDENT:
          return "Incident"
        case TicketType.JOB:
          return "Job"
        default:
          return ticketType
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-ticket-thread {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

section[name="header"] {
  .header__container {
    padding: 21px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header__text--topic {
    margin: 0;
    font-weight: 500;
    font-size: 18px;
  }
}

section[name="customer"] {
  .customer__container {
    padding: 0 21px 21px 21px;
  }

  .customer__name,
  .customer__email,
  .customer__phone {
    margin: 1rem 0 0 0;
  }
}

section[name="ticket-ticket-detail"] {
  .ticket-ticket-detail__container {
    padding: 21px 21px 21px 21px;
    position: relative;
  }

  .ticket-ticket-detail__button-edit {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0 21px 0 10px;
  }

  .ticket__container,
  .ticket-detail__container {
    width: 100%;
  }

  .ticket__topic {
    width: calc(100% - 50px);
  }

  .ticket__subject,
  .ticket__detail,
  .ticket__attachments,
  .ticket__priority,
  .ticket-detail__department,
  .ticket-detail__source,
  .ticket-detail__created-by,
  .ticket-detail__updated-by {
    display: block;
    margin: 1rem 0 0 0;

    overflow-wrap: break-word;
    word-break: break-word;
  }

  @media screen and (min-width: 1200px) {
    .ticket-ticket-detail__container {
      display: flex;
    }

    .ticket__container {
      width: 50%;
    }

    .ticket-detail__container {
      width: calc(50% - 50px);
    }

    .ticket__container {
      padding: 0 1rem 0 0;
    }

    .ticket-detail__container {
      padding: 0 0 0 1rem;
    }

    .ticket-detail__department {
      margin: 0;
    }
  }
}

section[name="ticket-thread"] {
  .ticket-thread__container {
    padding: 21px 21px 21px 21px;
  }

  .ticket-thread__header {
    margin: 0;
    color: #b9b9c3;
    font-weight: 500;
    font-size: 12px;
  }

  .duration__container {
    width: 100%;
    margin: 1rem 0 30px 0;
  }

  .duration__created,
  .duration__closed,
  .duration__duration {
    width: calc(100% / 3);
    display: flex;
    flex-direction: column;
  }

  .duration__created {
    padding: 0 1rem 0 0;
  }
  .duration__closed {
    padding: 0 0.5rem 0 0.5rem;
  }
  .duration__duration {
    padding: 0 0 0 1rem;
  }

  .duration__text--header {
    margin: 0;
    color: #5e5873;
    font-size: 12px;
  }

  .duration__text--body {
    width: 0;
    color: #5e5873;
    font-weight: 500;
    font-size: 12px;
  }

  @media screen and (min-width: 1200px) {
    .duration__container {
      width: 650px;
    }
  }
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.text--header {
  margin: 0 1rem 0 0;
  width: calc(100px - 1rem);
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
}

.text--body {
  margin: 0;
  width: calc(100% - 100px);
  color: #5e5873;
  font-size: 14px;
  white-space: pre-wrap;
}

.text--file {
  margin: 0;
  width: calc(100% - 100px);
  color: #7367f0;
  font-size: 14px;
  text-decoration-line: underline;
  cursor: pointer;
}

.text-width {
  width: calc(100% - 100px);
}

.input-container {
  width: 100%;
}

.input-container-small {
  width: 75px;
}

.button__height {
  min-height: 38px;
}

.button__container {
  position: absolute;
  bottom: 21px;
  right: 21px;
  display: flex;
  justify-content: flex-end;
}

.button__cancel {
  margin: 0 0 0 16px;
}

.attachment-width {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .text--header {
    width: 170px;
  }

  .text--body,
  .text--file {
    width: calc(100% - 170px);
  }

  .text-width {
    width: calc(100% - 170px);
  }

  .input-container {
    width: 325px;
  }

  .attachment-width {
    width: 80%;
  }
}

@media screen and (min-width: 992px) {
  .attachment-width {
    width: 65%;
  }
}

@media screen and (min-width: 1200px) {
}
</style>
